// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__yEgVW","close":"Modal_close__nnot4","svgRect":"Modal_svgRect__E6vzr","large":"Modal_large__szDwx","overlay":"Modal_overlay__b+zEz"};